var chunkMapping = {
	"35": [
		111,
		205,
		312,
		559,
		568,
		652,
		655,
		848,
		1012,
		1126,
		1335,
		1517,
		1526,
		1930,
		2040,
		2111,
		2591,
		2710,
		2948,
		3160,
		3406,
		3492,
		3542,
		4381,
		4428,
		5075,
		5621,
		5665,
		5695,
		6155,
		6317,
		6404,
		6467,
		6765,
		6835,
		6968,
		7122,
		7576,
		7579,
		7596,
		7599,
		7693,
		8513,
		8618,
		8726,
		8804,
		9266,
		9267,
		9300,
		9381,
		9439
	],
	"381": [
		7381
	],
	"518": [
		828,
		2391,
		2777,
		3580,
		5620,
		5894,
		6744,
		8626,
		9518,
		9684
	],
	"707": [
		137,
		9283
	]
};
var idToExternalAndNameMapping = {
	"111": [
		"default",
		"./Badge",
		3071
	],
	"137": [
		"default",
		"./register",
		1757
	],
	"205": [
		"default",
		"./Drawer",
		3071
	],
	"312": [
		"default",
		"./SearchFilter",
		3071
	],
	"559": [
		"default",
		"./Page",
		3071
	],
	"568": [
		"default",
		"./FiltersGroup",
		3071
	],
	"652": [
		"default",
		"./icons/Copy",
		3071
	],
	"655": [
		"default",
		"./icons/GoogleSquare",
		3071
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		616
	],
	"848": [
		"default",
		"./Request",
		1441
	],
	"1012": [
		"default",
		"./Col",
		3071
	],
	"1126": [
		"default",
		"./StatusFilter",
		3071
	],
	"1335": [
		"default",
		"./Text",
		3071
	],
	"1517": [
		"default",
		"./InputNumber",
		3071
	],
	"1526": [
		"default",
		"./icons/FacebookSquare",
		3071
	],
	"1930": [
		"default",
		"./FiltersBar",
		3071
	],
	"2040": [
		"default",
		"./EmptyStateSearch",
		3071
	],
	"2111": [
		"default",
		"./icons/Info",
		3071
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		616
	],
	"2591": [
		"default",
		"./Tooltip",
		3071
	],
	"2710": [
		"default",
		"./Row",
		3071
	],
	"2777": [
		"default",
		"./Image",
		3071
	],
	"2948": [
		"default",
		"./Card",
		3071
	],
	"3160": [
		"default",
		"./utils",
		1441
	],
	"3406": [
		"default",
		"./icons/Delete",
		3071
	],
	"3492": [
		"default",
		"./MultipleSelectFilter",
		3071
	],
	"3542": [
		"default",
		"./Table",
		3071
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		616
	],
	"4381": [
		"default",
		"./EmptyStateFilters",
		3071
	],
	"4428": [
		"default",
		"./Column",
		3071
	],
	"5075": [
		"default",
		"./RowContainer",
		3071
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		616
	],
	"5621": [
		"default",
		"./Popover",
		3071
	],
	"5665": [
		"default",
		"./Checkbox",
		3071
	],
	"5695": [
		"default",
		"./icons/Add",
		3071
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		616
	],
	"6155": [
		"default",
		"./StatusOption",
		3071
	],
	"6317": [
		"default",
		"./Modal",
		3071
	],
	"6404": [
		"default",
		"./EmptyStateData",
		3071
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6744": [
		"default",
		"./UnboxingPage",
		616
	],
	"6765": [
		"default",
		"./Avatar",
		3071
	],
	"6835": [
		"default",
		"./DateRangeFilter",
		3071
	],
	"6968": [
		"default",
		"./Form",
		3071
	],
	"7122": [
		"default",
		"./Switch",
		3071
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7576": [
		"default",
		"./Space",
		3071
	],
	"7579": [
		"default",
		"./RangePicker",
		3071
	],
	"7596": [
		"default",
		"./SelectCard",
		3071
	],
	"7599": [
		"default",
		"./notification",
		3071
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"8513": [
		"default",
		"./Icon",
		3071
	],
	"8618": [
		"default",
		"./Button",
		3071
	],
	"8626": [
		"default",
		"./icons/PeopleUnboxing",
		3071
	],
	"8726": [
		"default",
		"./Input",
		3071
	],
	"8804": [
		"default",
		"./InlineSegmentationBuilder",
		6784
	],
	"9266": [
		"default",
		"./Select",
		3071
	],
	"9267": [
		"default",
		"./icons/Edit",
		3071
	],
	"9283": [
		"default",
		"./unboxing-page",
		616
	],
	"9300": [
		"default",
		"./Alert",
		3071
	],
	"9381": [
		"default",
		"./FormItem",
		3071
	],
	"9439": [
		"default",
		"./icons/Plus",
		3071
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		616
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		616
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}